import { render, staticRenderFns } from "./MainNav.vue?vue&type=template&id=0b127910&scoped=true"
import script from "./MainNav.vue?vue&type=script&lang=js"
export * from "./MainNav.vue?vue&type=script&lang=js"
import style0 from "./MainNav.vue?vue&type=style&index=0&id=0b127910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b127910",
  null
  
)

export default component.exports